import { call, put, fork, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { eventChannel } from 'redux-saga';
import * as types from 'src/state/ducks/admin/types';
import * as actions from 'src/state/ducks/admin/actions';
import * as bakedBreadActions from 'src/state/ducks/bakedBread/actions';
import * as masterActions from 'src/state/ducks/master/actions';
import * as notificationActions from 'src/state/ducks/notification/actions';
import * as notificationTemplateActions from 'src/state/ducks/notificationTemplate/actions';
import * as orderActions from 'src/state/ducks/order/actions';
import * as orderItemActions from 'src/state/ducks/orderItem/actions';
import * as revenueActions from 'src/state/ducks/revenue/actions';
import * as shopActions from 'src/state/ducks/shop/actions';
import * as userActions from 'src/state/ducks/user/actions';
import * as api from 'src/state/ducks/admin/api';
import { firebase } from 'src/firebase';
// import { ReferenceError } from "src/firebase/db/ApplicationError"
import { Status } from 'src/constants/Interface';

const authChannel = () => {
  const channel = eventChannel((emit) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(
      (user) => emit({ user }),
      (error) => emit({ error }),
    );
    return unsubscribe;
  });
  return channel;
};

function* checkIsAuthenticated() {
  const channel = yield call(authChannel);
  while (true) {
    const { user, error }: { user: firebase.User; error: firebase.auth.Error } = yield take(
      channel,
    );
    try {
      if (user && !error) {
        const res = yield call(api.getUser, user.uid);
        const response_data = res.data;
        console.log(response_data);
        if (response_data.shops && response_data.shops.length === 1) {
          const currentShopId = response_data.shops[0].id;
          yield put(actions.chooseSigninShop(currentShopId));
        }
        yield put(actions.isLogin(res));
      } else {
        yield put(
          actions.failLogin({
            status: Status.FAILURE,
            error: {
              code: 401,
              message: error && error.message ? error.message : 'ログインされていない端末です',
            },
          }),
        );
      }
    } catch (err) {
      yield put(
        actions.failLogin({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* signIn() {
  while (true) {
    const action = yield take(types.LOGIN);
    try {
      const res = yield call(api.signIn, action.payload);
      const response_data = res.data;
      if (response_data.shops && response_data.shops.length === 1) {
        const currentShopId = response_data.shops[0].id;
        yield put(actions.chooseSigninShop(currentShopId));
      }
      yield put(actions.successLogin(res));
      yield put(push('/'));
    } catch (err) {
      console.log('err', err);
      yield put(
        actions.failLogin({
          status: Status.FAILURE,
          error: {
            code: 400,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* signOut() {
  while (true) {
    yield take(types.LOGOUT);
    try {
      yield call(api.signOut);
      yield put(actions.successLogout());

      // 取得済みのデータを初期化
      yield put(bakedBreadActions.initBakedBread());
      yield put(masterActions.initMaster());
      yield put(notificationActions.initNotification());
      yield put(notificationTemplateActions.initNotificationTemplate());
      yield put(orderActions.initOrder());
      yield put(orderItemActions.initOrderItem());
      yield put(revenueActions.initRevenue());
      yield put(shopActions.initShop());
      yield put(userActions.initUser());
      yield put(push('/login'));
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchSigninShop() {
  while (true) {
    try {
      const action = yield take(types.SELECT_SIGNIN_SHOP);
      console.log('dispatchSigninShop', action);
      yield put(actions.chooseSigninShop(action.payload));
    } catch (err) {
      throw err;
    }
  }
}

function* sendPasswordEmail() {
  while (true) {
    try {
      const action = yield take(types.SEND_FORGET_PASSWORD_MAIL);
      const response = yield call(api.sendPasswordReset, action.payload);
      console.log(response);
      yield put(actions.successForgetPassWordEmail(response));
    } catch (err) {
      console.log('err', err);
      yield put(
        actions.failForgetPassWordEmail({
          status: Status.FAILURE,
          error: {
            code: 400,
            message: err.message,
          },
        }),
      );
    }
  }
}

const adminSagas = [
  checkIsAuthenticated(),
  fork(signIn),
  fork(signOut),
  fork(dispatchSigninShop),
  fork(sendPasswordEmail),
];

export default adminSagas;
